module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vabdo3-f871d9e26b3302d3ecae722552d176be.jpg";